// v2.19.20 — Sophisticated loader full-width avec masque traditionnel CIV
// (Baoulé / Sénoufo / Dan / Guéré / Gouro) selon le mode thématique actif.
// Affiche un texte d'activité dynamique pour faire ressentir les étapes
// réelles du pipeline (rag → tools → llm → post-process). Remplace les
// 3 points "typing" legacy.

import React from "react";

// v2.19.23c — bascule sur PNG RGBA local sobre (sans inscription, alpha réel
// généré par flood-fill côté serveur). Un seul masque pour tous les modes.
const CIV_LOADER_MASK = "/aya/loader.png";
const CIV_MASK_BY_MODE = {
  casual:         CIV_LOADER_MASK,
  quotidien:      CIV_LOADER_MASK,
  sante:          CIV_LOADER_MASK,
  justice:        CIV_LOADER_MASK,
  shopping:       CIV_LOADER_MASK,
  divertissement: CIV_LOADER_MASK,
  culture:        CIV_LOADER_MASK,
  finance:        CIV_LOADER_MASK,
  business:       CIV_LOADER_MASK,
  administration: CIV_LOADER_MASK,
  street:         CIV_LOADER_MASK,
};
const DEFAULT_MASK = CIV_LOADER_MASK;

const PHASE_TEXTS = {
  listening:        "J'écoute ta question…",
  rag_fetching:     "Je consulte mes sources…",
  tools_calling:    "Je compare les meilleures options…",
  llm_thinking:     "Je formule ma reco…",
  streaming:        "J'écris ta réponse…",
  post_processing:  "Je peaufine…",
  thinking:         "AYA réfléchit…",
};

export default function SophisticatedLoader({ mode = "casual", phase = "thinking", modeLabel = "" }) {
  const baseText = PHASE_TEXTS[phase] || PHASE_TEXTS.thinking;
  const text = (phase === "rag_fetching" && modeLabel)
    ? `Je consulte mes sources ${modeLabel}…`
    : baseText;
  const maskUrl = CIV_MASK_BY_MODE[mode] || DEFAULT_MASK;
  return (
    <div className="civ-loader" data-testid="civ-sophisticated-loader" data-phase={phase}>
      <div className="civ-loader-mask-wrap">
        <img src={maskUrl} alt="CIV-AI" className="civ-loader-mask" loading="eager" />
        <div className="civ-loader-aura" />
      </div>
      <div className="civ-loader-text-wrap">
        <div className="civ-loader-text" key={text} data-testid="civ-loader-text">{text}</div>
        <div className="civ-loader-progress"><span /></div>
      </div>
    </div>
  );
}

export { CIV_MASK_BY_MODE, PHASE_TEXTS };
